import React from "react";
import Webcam from "react-webcam";
import VideoLoading from "assets/img/cameraLoading.png";
import Button from "shared/components/button";
import SelectDropdown from "shared/form/core/selectDropdown";
import { useCopies } from "shared/hooks/useCopies";
import useWebCamCapture from "./captureImageService";
import { WebcamCaptureProps } from "./type";
import ButtonGroup from "shared/components/button/components/buttonGroup";

export function WebcamCapture({
  setCapturedImage,
  handleError,
  handleCancel,
  handleBrowserSupport
}: WebcamCaptureProps) {
  const copies = useCopies();
  const service = useWebCamCapture(setCapturedImage, handleBrowserSupport);
  return (
    <div className="webCam">
      <div className="webCam_video">
        {!service.state.browserSupportError && (
          <Webcam
            mirrored={true}
            audio={false}
            ref={service.webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={service.videoConstraints}
            onUserMedia={() => {
              service.setState(state => ({
                ...state,
                loading: false
              }));
            }}
            autoPlay={true}
            poster={VideoLoading}
            onUserMediaError={() => {
              service.setState(state => ({
                ...state,
                loading: false
              }));
              handleError();
            }}
          />
        )}
      </div>
      {service?.state?.devices?.length && service?.state?.devices?.length > 1 && (
        <SelectDropdown
          options={service.optionsForDeviceSelect}
          placeholder={copies.get("select.device")}
          onChange={service.handleDeviceSelect}
          defaultValue={
            service.state.selectedDevice
              ? {
                  label: service.state.selectedDevice?.label,
                  value: service.state.selectedDevice?.deviceId
                }
              : null
          }
        />
      )}
      <ButtonGroup fullWidth>
        <React.Fragment>
          <Button
            label={copies.get("capture")}
            onClick={e => {
              e.preventDefault();
              service.capture();
            }}
          />
          <Button isOutline label={copies.get("cancel")} onClick={handleCancel} />
        </React.Fragment>
      </ButtonGroup>
    </div>
  );
}
